import type { ThemeV3 } from '../types/themeTypes';

export const floraTheme: ThemeV3 = {
  id: 'Flora',
  name: 'Flora',
  version: 3,
  mode: 'light',
  colorTokens: {
    'surface-0': 'oklch(92.74% 0.0134 92)',
    'surface-1':
      'color-mix(in srgb, var(--color-surface-0) 56%, var(--color-surface-4))',
    'surface-2':
      'color-mix(in srgb, var(--color-surface-0) 27%, var(--color-surface-4))',
    'surface-3':
      'color-mix(in srgb, var(--color-surface-0) 6%, var(--color-surface-4))',
    'surface-4': 'oklch(1 0 150deg)',
    'content-0': 'oklch(32.49% 0.0365 150)',
    'content-1':
      'color-mix(in srgb, var(--color-content-0) 76%, var(--color-content-4))',
    'content-2':
      'color-mix(in srgb, var(--color-content-0) 54%, var(--color-content-4))',
    'content-3':
      'color-mix(in srgb, var(--color-content-0) 15%, var(--color-content-4))',
    'content-4': 'oklch(73.59% 0.0319 150.2)',
    edge: 'oklch(79.13% 0.045 78 / 0.7)',
    'edge-muted': 'oklch(81.55% 0.0382 98 / 0.76)',
    accent: 'oklch(65.07% 0.1903 336)',
    red: 'oklch(61.06% 0.1705 24.97)',
    orange: 'oklch(67.07% 0.1759 50.19)',
    amber: 'oklch(76.45% 0.1675 70.08)',
    yellow: 'oklch(82.38% 0.238 86.05)',
    lime: 'oklch(78.46% 0.2278 120)',
    green: 'oklch(73.51% 0.1207 159)',
    teal: 'oklch(51.34% 0.0896 185.5)',
    cyan: 'oklch(67.9% 0.1385 233)',
    blue: 'oklch(0.55 0.16 259.815deg)',
    violet: 'oklch(0.55 0.16 292.717deg)',
    purple: 'oklch(0.55 0.16 303.9deg)',
    pink: 'oklch(86.77% 0.2673 354.3)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    lift: 'var(--layer-lift)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'oklch(82.4% 0.1172 0 / 0.07)',
    'input-focus': 'var(--color-lift)',
    message: 'var(--color-lift)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-yellow)',
    failure: 'var(--color-red)',
    chrome: 'var(--color-surface-4)',
  },
};
